var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPatronizeOpens = function SvgPatronizeOpens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409FFF",
    fillRule: "nonzero",
    d: "M14.124 0c3.085 0 5.593 2.458 5.593 5.5v4.999l8.175.001a4.1 4.1 0 0 1 2.943 1.196l.162.171a3.96 3.96 0 0 1 .956 3.238l-2.112 13.498c-.306 1.974-2.04 3.42-4.05 3.397H8a1 1 0 0 1-1-1V14.5a1 1 0 0 1 .09-.413l6.123-13.5A1 1 0 0 1 14.124 0M4.471 14c.497 0 .9.425.9.948v16.104c0 .523-.403.947-.9.947h-1.09C1.247 32.037.3 30.45.01 28.286L0 28.153V18.007l.009-.132C.303 15.689 1.267 13.963 3.366 14z"
  }))));
};
export default SvgPatronizeOpens;